import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFetchEventSessionAttendees, ATTENDEES_PER_PAGE } from 'actions/eventSessions';
import { useAppNameContext } from 'hooks/useAppNameContext';
import useSearchParams from 'hooks/useSearchParams';
import { getPageFromQuery, getNumberOfPages, locationWithPageNumber } from 'utils/pagination';
import Stack from 'components/Stack';
import Flex from 'components/Flex';
import Text from 'components/Text';
import SearchBox from 'components/SearchBox';
import EmptyStateController from 'components/EmptyStateController';
import Landmark from 'components/Landmark';
import TableCard, { Column, InteractiveTableContent } from 'components/TableCard';
import UserTableCell from 'components/UserTableCell';
import { Select, Option } from 'components/Select';
import VisuallyHidden from 'components/VisuallyHidden';
import TitleCard from 'components/TitleCard';
import Button from 'components/Button';
import { sessionQueryParameters } from '../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var attendeeStatusOptions = ['booked', 'cancelled', 'attended', 'noshow'];
function isAttendeeStatus(value) {
  return Boolean(value && attendeeStatusOptions.includes(value));
}
function getStatusLabel(t, status) {
  if (status === 'booked') {
    return t('state_booked');
  }
  if (status === 'cancelled') {
    return t('state_cancelled');
  }
  if (status === 'attended') {
    return t('state_attended');
  }
  return t('state_no_show');
}
function getAttendeeKey(attendee) {
  return String(attendee.id);
}
function SessionAttendeesPage(_ref) {
  var isNested = _ref.isNested,
    eventId = _ref.eventId,
    sessionId = _ref.sessionId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];
  var attendeesPageQueryParameter = sessionQueryParameters.attendeesPage;
  var attendeesSearchQueryParameter = sessionQueryParameters.attendeesSearch;
  var attendeesStatusQueryParameter = sessionQueryParameters.attendeesStatus;
  var currentPage = getPageFromQuery({
    query: searchParams,
    pageQueryParameter: attendeesPageQueryParameter
  });
  var searchValue = searchParams[attendeesSearchQueryParameter];
  var statusValue = isAttendeeStatus(searchParams[attendeesStatusQueryParameter]) ? searchParams[attendeesStatusQueryParameter] : undefined;
  var _useState = useState(searchValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    searchInput = _useState2[0],
    setSearchInput = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAttendeeIds = _useState4[0],
    setSelectedAttendeeIds = _useState4[1];
  var appNameContext = useAppNameContext();
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    attendeeStatusById = _useState6[0],
    setAttendeeStatusById = _useState6[1];
  useEffect(function () {
    setSearchInput(searchValue || '');
  }, [searchValue]);
  var _useFetchEventSession = useFetchEventSessionAttendees({
      eventId: eventId,
      sessionId: sessionId,
      page: currentPage,
      limit: ATTENDEES_PER_PAGE,
      search: searchValue,
      status: statusValue
    }),
    attendees = _useFetchEventSession.items,
    total = _useFetchEventSession.total,
    isAttendeesListLoading = _useFetchEventSession.isLoading,
    isAttendeesListError = _useFetchEventSession.isError;
  var pageCount = getNumberOfPages({
    total: total,
    itemsPerPage: ATTENDEES_PER_PAGE
  });
  var attendeesRows = useMemo(function () {
    return attendees.map(function (attendee) {
      return _objectSpread(_objectSpread({}, attendee), {}, {
        resolvedStatus: attendeeStatusById[getAttendeeKey(attendee)] || attendee.status
      });
    });
  }, [attendees, attendeeStatusById]);
  function onSubmitSearch(e) {
    e.preventDefault();
    setSearchParams(_defineProperty(_defineProperty({}, attendeesPageQueryParameter, 1), attendeesSearchQueryParameter, searchInput.trim() || undefined));
  }
  function onClearSearch() {
    setSearchInput('');
    setSearchParams(_defineProperty(_defineProperty({}, attendeesPageQueryParameter, 1), attendeesSearchQueryParameter, undefined));
  }
  function onChangeStatusFilter(value) {
    setSearchParams(_defineProperty(_defineProperty({}, attendeesPageQueryParameter, 1), attendeesStatusQueryParameter, value || undefined));
  }
  function onChangeAttendeeStatus(attendeeId, nextStatus) {
    setAttendeeStatusById(function (currentStatusById) {
      return _objectSpread(_objectSpread({}, currentStatusById), {}, _defineProperty({}, attendeeId, nextStatus));
    });
  }
  return /*#__PURE__*/_jsx(TitleCard, {
    title: t('actions_manage_attendees'),
    variant: "raised",
    headingLevel: isNested ? 'h3' : 'h2',
    sideContent: /*#__PURE__*/_jsx(Button, {
      icon: "plus",
      size: "medium",
      variant: "primary"
      // eslint-disable-next-line no-console
      ,
      onClick: function onClick() {
        return console.log('actions_add_members');
      },
      children: t('actions_add_members')
    }),
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "m",
      children: [/*#__PURE__*/_jsxs(Flex, {
        align: "center",
        justifyContent: "space-between",
        gap: "s",
        children: [/*#__PURE__*/_jsx("form", {
          onSubmit: onSubmitSearch,
          children: /*#__PURE__*/_jsx(SearchBox, {
            withBorder: true,
            label: t('actions_search_members'),
            placeholder: t('actions_search_members'),
            value: searchInput,
            onChange: function onChange(e) {
              return setSearchInput(e.currentTarget.value);
            },
            onClear: onClearSearch
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          align: "center",
          gap: "xxs",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "label",
            id: "attendees-status-filter-label",
            mr: "xxs",
            children: t('actions_filter_by_attendance_status_colon')
          }), /*#__PURE__*/_jsxs(Select, {
            size: "medium",
            labelledById: "attendees-status-filter-label",
            menuPlacement: "bottom-end",
            value: statusValue || '',
            onChange: onChangeStatusFilter,
            variant: "transparent",
            children: [/*#__PURE__*/_jsx(Option, {
              value: "",
              children: t('state_any')
            }), /*#__PURE__*/_jsx(Option, {
              value: "booked",
              children: t('state_booked')
            }), /*#__PURE__*/_jsx(Option, {
              value: "cancelled",
              children: t('state_cancelled')
            }), /*#__PURE__*/_jsx(Option, {
              value: "attended",
              children: t('state_attended')
            }), /*#__PURE__*/_jsx(Option, {
              value: "noshow",
              children: t('state_no_show')
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx(EmptyStateController, {
        isError: isAttendeesListError,
        height: 250,
        children: /*#__PURE__*/_jsxs(TableCard, {
          isSelectionTable: true,
          isLoading: isAttendeesListLoading,
          emptyContent: /*#__PURE__*/_jsx(Landmark, {
            icon: "user",
            height: 250,
            children: t('empty_no_members')
          }),
          data: attendeesRows,
          itemKey: "id",
          selectedItems: selectedAttendeeIds,
          onChangeSelectedItems: setSelectedAttendeeIds,
          getItemLabel: function getItemLabel(attendee) {
            return attendee.name;
          },
          pageCount: pageCount,
          currentPage: currentPage,
          getPageLink: function getPageLink(pageNumber) {
            return locationWithPageNumber({
              location: location,
              page: pageNumber,
              pageQueryParameter: attendeesPageQueryParameter
            });
          },
          rowHeader: t('property_member'),
          headerRenderer: function headerRenderer(column) {
            return /*#__PURE__*/_jsx(Text, {
              bold: true,
              children: column.title
            });
          },
          children: [/*#__PURE__*/_jsx(Column, {
            title: t('property_member'),
            name: "name",
            cellRenderer: function cellRenderer(attendee) {
              var isDeleted = attendee.isDeleted;
              var link = "/admin/users?search=".concat(encodeURIComponent("id:".concat(attendee.userId).concat(isDeleted ? ' is:deleted' : '')));
              return /*#__PURE__*/_jsx(UserTableCell, {
                target: appNameContext === 'admin' ? '' : '_blank',
                id: attendee.userId,
                link: link,
                email: attendee.email,
                userName: attendee.name,
                avatarUrl: attendee.pictureUrl || undefined,
                isDeleted: isDeleted
              });
            }
          }), /*#__PURE__*/_jsx(Column, {
            title: t('property_attendance_status'),
            name: "resolvedStatus",
            width: "30%",
            cellRenderer: function cellRenderer(attendee) {
              var attendeeId = getAttendeeKey(attendee);
              var selectedStatus = attendee.resolvedStatus;
              var statusLabelId = "attendee-status-".concat(attendeeId, "-label");
              return /*#__PURE__*/_jsxs(InteractiveTableContent, {
                children: [/*#__PURE__*/_jsx(VisuallyHidden, {
                  id: statusLabelId,
                  children: t('property_attendance_status')
                }), /*#__PURE__*/_jsx(Select, {
                  size: "small",
                  labelledById: statusLabelId,
                  menuPlacement: "bottom-start",
                  value: selectedStatus,
                  onChange: function onChange(nextStatus) {
                    return onChangeAttendeeStatus(attendeeId, nextStatus);
                  },
                  children: attendeeStatusOptions.map(function (status) {
                    return /*#__PURE__*/_jsx(Option, {
                      value: status,
                      children: getStatusLabel(t, status)
                    }, status);
                  })
                })]
              });
            }
          })]
        })
      })]
    })
  });
}
export default SessionAttendeesPage;